// Token storage that adapts based on PWA install state.
//
// - Normal browser tab  : sessionStorage (clears on tab close — security)
// - Installed PWA       : localStorage   (persists across app launches — mobile app feel)
//
// Detected via `display-mode: standalone` and iOS `navigator.standalone`.

const isStandalone = () => {
  try {
    const mql = window.matchMedia && window.matchMedia("(display-mode: standalone)");
    return (mql && mql.matches) || window.navigator.standalone === true;
  } catch (_e) {
    return false;
  }
};

export const isPwaStandalone = isStandalone;

export const tokenStore = {
  get() {
    try {
      if (isStandalone()) return localStorage.getItem("token");
      return sessionStorage.getItem("token");
    } catch (_e) {
      return null;
    }
  },
  set(value) {
    try {
      if (isStandalone()) {
        localStorage.setItem("token", value);
      } else {
        sessionStorage.setItem("token", value);
      }
    } catch (_e) { /* noop */ }
  },
  clear() {
    try { sessionStorage.removeItem("token"); } catch (_e) { /* noop */ }
    try { localStorage.removeItem("token"); } catch (_e) { /* noop */ }
  },
};
